<template>
  <b-modal
    id="addComatFlightModal"
    ref="addComatFlightModal"
    hide-footer
    hide-header
    size="xl"
    title="erere"
    body-class="modal-body-wo"
    @hide="modalHiding"
  >
    <modal-window :mainWidth="12">
      <div>
        <div class="label">Possible Routings</div>
        <div class="d-flex justify-content-between text-center filter-menu mb-4">
          <div class="first-filter">
            <div class="label">Date</div>
            <board-item-date-picker v-model="filters.date" mode="date"></board-item-date-picker>
          </div>
          <div>
            <div class="label">Flight</div>
            <input type="text" class="form-control" v-model="filters.flightNo" />
          </div>
          <div>
            <div class="label">Operator</div>
            <input type="text" class="form-control" v-model="filters.operator" />
          </div>
          <div>
            <div class="label">Type</div>
            <input type="text" class="form-control" v-model="filters.aircraftType" />
          </div>
          <div>
            <div class="label">Registration</div>
            <input type="text" class="form-control" v-model="filters.aircraftRegistration" />
          </div>
          <div>
            <div class="label">Departure</div>
            <input type="text" class="form-control" v-model="filters.departureAirport" />
          </div>
          <div>
            <div class="label">Arrival</div>
            <input type="text" class="form-control" v-model="filters.arrivalAirport" />
          </div>
          <div class="">
            <div class="label">State</div>
            <input type="text" class="form-control" v-model="filters.flightState" />
          </div>
        </div>

        <div class="mt-2 mb-3" v-for="(route, index) in filteredcomatRouting" :key="index">
          <div class="d-flex justify-content-between">
            <div class="label">Route {{ index + 1 }} - {{route.numberOfFlights}} Flights</div>
            <div style="min-width: 65px;">
              <button class="btn btn-block btn-sm btn-success mb-1" @click="saveComatRoute(route)">
                Select
              </button>
            </div>
          </div>

          <div v-for="flight in route.flights" :key="flight.id">
            <FlightInfo :flight="flight"></FlightInfo>
          </div>
        </div>
      </div>
    </modal-window>
  </b-modal>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { ComatRoutingDto, FlightInfoDto } from "@/apiclient/apiclient_generated";
  import { SpecialOccurrenceModule, SpecialOccurrenceStore } from '@/store/specialOccurrence';
  import FlightInfo from '@/components/SpecialOccurrence/Data/Flights/FlightInfo.vue';
  import ModalWindow from '@/components/ModalWindow.vue';
  import { DateTime } from 'luxon';
  import BoardItemDatePicker from "@/components/BoardItem/BoardItemDatePicker.vue";

  @Component({
    components: {
      BoardItemDatePicker,
      FlightInfo,
      ModalWindow,
    },
  })
  export default class ComatFlightsSelector extends Vue {
    private store: SpecialOccurrenceModule = SpecialOccurrenceStore;
    private filters: FlightInfoDto = new FlightInfoDto();

    mounted() {
      this.$bvModal.show('addComatFlightModal');
    }

    private dateFilter = (filterDate: DateTime, date: string) => {
      const itemDate = DateTime.fromISO(date);

      return itemDate.isValid && filterDate?.isValid
        ? itemDate.year === filterDate.year &&
            itemDate.month === filterDate.month &&
            itemDate.day === filterDate.day
        : true;
    };

    private stringFilter = (filter: string, source: string) => {
      return filter ? source?.toLowerCase().includes(filter.toLowerCase()) : true;
    };

    get filteredcomatRouting() {
      const originalRoutings: ComatRoutingDto[] = this.store.comatRoutings;

      let filterDate: DateTime;

      if (this.filters.date) {
        filterDate = DateTime.fromISO(this.filters.date);
      }

      const result = originalRoutings.filter((_) => {
        return _.flights.some(
          (_) =>
            this.dateFilter(filterDate, _.date) &&
            this.stringFilter(this.filters.flightNo, _.flightNo) &&
            this.stringFilter(this.filters.operator, _.operator) &&
            this.stringFilter(this.filters.aircraftType, _.aircraftType) &&
            this.stringFilter(this.filters.aircraftRegistration, _.aircraftRegistration) &&
            this.stringFilter(this.filters.departureAirport, _.departureAirport) &&
            this.stringFilter(this.filters.arrivalAirport, _.arrivalAirport) &&
            this.stringFilter(this.filters.flightState, _.flightState)
        );
      });

      return result;
    }

    async saveComatRoute(route: ComatRoutingDto) {
      this.$emit('saveComatRoute', route.flights);
      await this.closeModal();
    }

    async closeModal() {
      this.$emit('closeRoutesModal');
      await this.$root.$emit('bv::hide::modal', 'addComatFlight');
    }

    modalHiding() {
      this.closeModal();
    }
  }
</script>

<style lang="scss">
  .filter-menu > div {
    margin-right: 10px;
  }
  .filter-menu > div:last-child {
    margin-right: 0;
  }

  .first-filter {
    min-width: 120px;
    .field.sm {
      height: 33.49px !important;
      min-height: 33.49px !important;
    }
  }
</style>
